import React from 'react';
import styles from './GeoLabel.css';

import { IGeoLabel } from '../../types/geo';

interface IGeoLabelProps extends IGeoLabel {
  onLabelClick(label: string): void;
}

export function GeoLabel({ url, label, type, onLabelClick }: IGeoLabelProps) {
  const Elem = React.useMemo(() => (url ? 'a' : 'span'), [url]);

  const handleClick = React.useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();

      onLabelClick(type);
    },
    [onLabelClick, type],
  );

  return (
    <Elem className={styles['link']} href={url} target="_blank" onClick={handleClick}>
      {label}
    </Elem>
  );
}
